import { render, staticRenderFns } from "./groups-number.vue?vue&type=template&id=603272ba&scoped=true&"
import script from "./groups-number.vue?vue&type=script&lang=js&"
export * from "./groups-number.vue?vue&type=script&lang=js&"
import style0 from "./groups-number.vue?vue&type=style&index=0&id=603272ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603272ba",
  null
  
)

export default component.exports